import { module } from 'angular';

import {
  Attachment,
  BarChart,
  Button,
  Chosen,
  ColorGrade,
  ColorPicker,
  Comment,
  CsvImport,
  DatePicker,
  FileInput,
  Filter,
  FontResize,
  IframeOnload,
  ImageReader,
  Link,
  List,
  MediaPlayer,
  PeriodSelector,
  Permission,
  PieChart,
  RadioButton,
  RecipientsInfoTooltip,
  Spinner,
  Switch,
} from './';

export default module('contact.commons.toolbox', [
  Attachment,
  BarChart,
  Button,
  Chosen,
  ColorGrade,
  ColorPicker,
  Comment,
  CsvImport,
  DatePicker,
  ImageReader,
  Filter,
  FontResize,
  IframeOnload,
  Link,
  List,
  MediaPlayer,
  PeriodSelector,
  Permission,
  PieChart,
  RadioButton,
  RecipientsInfoTooltip,
  Spinner,
  Switch,
  FileInput,
]).name;
